export * from './ColorEditor';
export { default } from './ColorEditor';
